<template>
    <div class="door-check-add">
        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">
                    <h2 class="page-header-title">
                        <router-link to="/">
                            Door Inspection</router-link>
                        &raquo;
                        <span v-if="isEdit">
                        <router-link :to="{ name: 'door-check-view', params: {action: 'view', id: doorCheck.site_door_check_id} }">
                            {{ doorCheck.document_id }} | {{ doorCheck.document_title }}
                        </router-link>
                             &raquo;
                            </span>
                        <span v-if="isEdit">
                                  Edit Door Inspection</span><span v-else>  Add new Door Inspection</span></h2>
                </div>
            </div>
        </div>

        <form @submit.prevent="submit">
            <div class="form-body">
                <input
                        name="site_door_check_id"
                        type="hidden"
                        v-model="doorCheck.site_door_check_id"
                >
                <div style="display:none;">
                    <div class="col-lg-6 col-md-12"><input type="hidden" name="_method" value="POST"/></div>
                </div>
                <div class="form-body">

                    <div class="row">
                        <div class="col-sm-12 widget-20">
                            <div class="widget has-shadow">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Site Details</h2>
                                </div>
                                <div class="widget-body">
                                    <div class="form-group row d-flex align-items-center required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('document_id')]"
                                               for="document-id">Document ID</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="document_id"
                                                    :class="['form-control', getFieldClasses('document_id')]"
                                                    maxlength="255"
                                                    id="document-id"
                                                    v-model="doorCheck.document_id"
                                                    @blur="onFieldBlur('document_id')"
                                            />
                                            <div v-if="isErrorField('document_id')" class="invalid-feedback">This field is required</div>
                                        </div>

                                    </div>
                                    <div class="form-group row d-flex align-items-center  required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('document_title')]"
                                                for="document-title">Title</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="document_title"
                                                    :class="['form-control', getFieldClasses('document_title')]"
                                                    maxlength="255"
                                                    id="document-title"
                                                    v-model="doorCheck.document_title"
                                                    @blur="onFieldBlur('document_title')"
                                            />
                                            <div v-if="isErrorField('document_title')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center  required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('client_site')]"
                                               for="client-site">Client Site</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="client_site"
                                                    :class="['form-control', getFieldClasses('client_site')]"
                                                    v-model="doorCheck.client_site"
                                                    id="client-site"
                                                    @blur="onFieldBlur('client_site')"
                                            /></div>
                                        <div v-if="isErrorField('client_site')" class="invalid-feedback">This field is required</div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center" v-if="dbName !== 'jpfire' && doorCheck.use_bm_trada_template">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('rma_form_sequential_ref_no')]"
                                               for="rma_form_sequential_ref_no">RMA Form Sequential Reference Number</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="rma_form_sequential_ref_no"
                                                    :class="['form-control', getFieldClasses('rma_form_sequential_ref_no')]"
                                                    v-model="doorCheck.rma_form_sequential_ref_no"
                                                    id="rma_form_sequential_ref_no"
                                                    @blur="onFieldBlur('rma_form_sequential_ref_no')"
                                            /></div>
                                        <div v-if="isErrorField('rma_form_sequential_ref_no')" class="invalid-feedback">This field is required</div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="date-of-inspection">
                                            Date Of Inspection
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <datepicker
                                                    v-model="doorCheck.date_of_inspection"
                                                    format="dd/MM/yy"
                                                    input-class="form-control"
                                                    name="date_of_inspection"
                                            ></datepicker>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center" v-if="dbName === 'qfpc'">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="prepared-by">
                                            Prepared by
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="prepared_by"
                                                    :class="['form-control', getFieldClasses('prepared_by')]"
                                                    maxlength="255"
                                                    v-model="doorCheck.prepared_by"
                                                    id="prepared-by"
                                                    @blur="onFieldBlur('prepared_by')"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center" v-if="dbName === 'qfpc' && isEdit">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="edited-by">
                                            Edited by
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="edited_by"
                                                    :class="['form-control', getFieldClasses('edited_by')]"
                                                    maxlength="255"
                                                    v-model="doorCheck.edited_by"
                                                    id="edited-by"
                                                    @blur="onFieldBlur('edited_by')"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('location')]"
                                                for="location">
                                            Location
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="location"
                                                    :class="['form-control', getFieldClasses('location')]"
                                                    maxlength="255"
                                                    v-model="doorCheck.location"
                                                    id="location"
                                                    @blur="onFieldBlur('location')"
                                            />
                                            <div v-if="isErrorField('location')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center" v-if="dbName === 'qfpc'">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('country')]"
                                                for="country">
                                            Country
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="country"
                                                    id="country"
                                                    :class="['form-control', getFieldClasses('country')]"
                                                    v-model="doorCheck.country"
                                                    @blur="onFieldBlur('country')"
                                                    @change="onCountryChange()"
                                            >
                                                <option value="England">England</option>
                                                <option value="Scotland">Scotland</option>
                                            </select>
                                            <div v-if="isErrorField('country')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center ">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"  for="notes">
                                            Notes
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <textarea
                                                    class="form-control"
                                                    name="notes"
                                                    maxlength="2000"
                                                    id="notes"
                                                    rows="5"
                                                    v-model="doorCheck.notes"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center mb-5 required">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <p>Include notes on report?</p>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li style="width: 45%">
                                                    <input type="radio" :value="true" id="inor-yes"
                                                           name="include_notes_on_report"
                                                           class="button-positive"
                                                           v-model="doorCheck.include_notes_on_report"
                                                    >
                                                    <label for="inor-yes">Yes</label>
                                                </li>
                                                <li style="width: 45%">
                                                    <input type="radio" :value="false" id="inor-no"
                                                           name="include_notes_on_report"
                                                           class="button-negative"
                                                           v-model="doorCheck.include_notes_on_report"
                                                    >
                                                    <label for="inor-no">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center" v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('client_provided_info_schedule')]"
                                                for="client_provided_info_schedule">
                                            Schedule of Client Provided Information
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <multiselect
                                                    :searchable="false"
                                                    :close-on-select="false"
                                                    v-model="doorCheck.client_provided_info_schedule"
                                                    :options="cpiScheduleItems"
                                                    :show-labels="false"
                                                    :multiple="true"
                                                    id="client_provided_info_schedule"
                                            ></multiselect>
                                            <div v-if="isErrorField('client_provided_info_schedule')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center ">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="disclaimer">
                                            Disclaimer
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <textarea
                                                    class="form-control"
                                                    name="disclaimer"
                                                    rows="10"
                                                    maxlength="2000"
                                                    v-model="doorCheck.disclaimer"
                                                    id="disclaimer"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center mb-5 required">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <p>Should the report be branded?</p>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li style="width: 45%">
                                                    <input
                                                        type="radio"
                                                        :value="false"
                                                        id="iru-yes"
                                                        name="is_report_unbranded"
                                                        class="button-positive"
                                                        v-model="doorCheck.is_report_unbranded"
                                                    >
                                                    <label for="iru-yes">Yes</label>
                                                </li>
                                                <li style="width: 45%">
                                                    <input
                                                        type="radio"
                                                        :value="true"
                                                        id="iru-no"
                                                        name="is_report_unbranded"
                                                        class="button-negative"
                                                        v-model="doorCheck.is_report_unbranded"
                                                    >
                                                    <label for="iru-no">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center mb-5 required" v-if="dbName !== 'jpfire'">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <p>Is this being carried out under BM Trada?</p>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li style="width: 45%">
                                                    <input
                                                        type="radio"
                                                        :value="true"
                                                        id="ubt-yes"
                                                        name="use_bm_trada_template"
                                                        class="button-positive"
                                                        v-model="doorCheck.use_bm_trada_template"
                                                    >
                                                    <label for="ubt-yes">Yes</label>
                                                </li>
                                                <li style="width: 45%">
                                                    <input
                                                        type="radio"
                                                        :value="false"
                                                        id="ubt-no"
                                                        name="use_bm_trada_template"
                                                        class="button-negative"
                                                        v-model="doorCheck.use_bm_trada_template"
                                                    >
                                                    <label for="ubt-no">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center mb-5 required" v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <p>Is this Third Party Report?</p>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li style="width: 45%">
                                                    <input
                                                        type="radio"
                                                        :value="true"
                                                        id="tpr-yes"
                                                        name="is_third_party_report"
                                                        class="button-positive"
                                                        v-model="doorCheck.is_third_party_report"
                                                    >
                                                    <label for="tpr-yes">Yes</label>
                                                </li>
                                                <li style="width: 45%">
                                                    <input
                                                        type="radio"
                                                        :value="false"
                                                        id="tpr-no"
                                                        name="is_third_party_report"
                                                        class="button-negative"
                                                        v-model="doorCheck.is_third_party_report"
                                                    >
                                                    <label for="tpr-no">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row align-items-center" v-if="dbName !== 'jpfire'">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            Inspector Signature
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="signature-area" v-if="doorCheck.offline_engineer_signature_image != null">
                                                <img v-bind:src="doorCheck.offline_engineer_signature_image.data" class="img-fluid">
                                            </div>
                                            <div v-else-if="doorCheck.engineer_signature_image != null">
                                                Report signed by inspector
                                            </div>
                                            <div class="pt-2">
                                                <div v-if="addingEngineerSignature">
                                                    <div class="signature-area">
                                                        <VueSignaturePad width="100%" height="200px" ref="engineerSignaturePad" />
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="saveEngineerSignature">Save signature</a>
                                                        </div>
                                                        <div class="col-6">
                                                            <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="clearEngineerSignature">Clear signature</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                    href="javascript:void(0)"
                                                    v-on:click="addEditEngineerSignature"
                                                ><span v-if="doorCheck.offline_engineer_signature_image != null || doorCheck.engineer_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row align-items-center" :class="{ 'd-none': dbName === 'jpfire', 'd-flex': dbName !== 'jpfire'  }">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            Client Signature
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="signature-area" v-if="doorCheck.offline_client_signature_image != null">
                                                <img v-bind:src="doorCheck.offline_client_signature_image.data" class="img-fluid">
                                            </div>
                                            <div v-else-if="doorCheck.client_signature_image != null">
                                                Report signed by client
                                            </div>
                                            <div class="pt-2">
                                                <div v-if="addingClientSignature">
                                                    <div class="signature-area">
                                                        <VueSignaturePad width="100%" height="200px" ref="clientSignaturePad" />
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="saveClientSignature">Save signature</a>
                                                        </div>
                                                        <div class="col-6">
                                                            <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="clearClientSignature">Clear signature</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                    href="javascript:void(0)"
                                                    v-on:click="addEditClientSignature"
                                                ><span v-if="doorCheck.offline_client_signature_image != null || doorCheck.client_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row align-items-center required" :class="{ 'd-none': dbName === 'jpfire', 'd-flex': dbName !== 'jpfire'  }">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('client_signed_by')]"
                                               for="client-name">Client Name</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="client_signed_by"
                                                    :class="['form-control', getFieldClasses('client_signed_by')]"
                                                    v-model="doorCheck.client_signed_by"
                                                    id="client-name"
                                                    @blur="onFieldBlur('client_signed_by')"
                                            /></div>
                                        <div v-if="isErrorField('client_signed_by')" class="invalid-feedback">This field is required</div>
                                    </div>

                                    <div class="alert alert-danger" v-if="isError">
                                        <p class="mb-0">
                                            <strong>The following fields have errors or are missing:</strong>
                                        </p>
                                        <ul class="mb-0 pl-3" v-if="errors.length > 0">
                                            <li v-for="error in errors" v-bind:key="error.field">
                                                <span v-if="error.field">{{ 'form.'+error.field }}<span v-if="error.message">: error.message</span></span>
                                                <span v-else-if="error.message">error.message</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">

                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                    <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                    <span v-else>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>

    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
    .form-control {
        background: #fff !important;
    }
    .vdp-datepicker__calendar .selected {
        background: var(--primary-color) !important;
        color: #fff;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid var(--primary-color) !important;
    }
</style>

<script>
    import { required } from 'vuelidate/lib/validators'

    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';
    import Multiselect from 'vue-multiselect';
    import PageLeaveConfirm from '@/components/mixins/PageLeaveConfirm.js';

    export default {
        mixins: [PageLeaveConfirm],
        data() {
            return {
                retryDoorCheckCount: 0,
                addingClientSignature: false,
                addingEngineerSignature: false,
                isEdit: false,
                isSubmitted: false,
                isError: false,
                errorHeader: 'error.invalidFields',
                errors: [],
                submitting: false,
                doorCheck: {
                    site_door_check_id: Math.floor(new Date().getTime() / 1000),
                    door_check_id: null,
                    document_id: null,
                    document_title: null,
                    client_site: null,
                    rma_form_sequential_ref_no: null,
                    date_of_inspection: new Date(),
                    prepared_by: null,
                    edited_by: null,
                    location: null,
                    country: 'England',
                    notes: null,
                    include_notes_on_report: true,
                    disclaimer: 'Loading default disclaimer...',
                    client_provided_info_schedule: null,
                    is_report_unbranded: false,
                    use_bm_trada_template: false,
                    is_third_party_report: false,
                    client_signature_image: null,
                    offline_client_signature_image: null,
                    engineer_signature_image: null,
                    offline_engineer_signature_image: null,
                    client_signed_by: null,
                    report_version: null
                },
                cpiScheduleItems: [],
                defaultDisclaimer: null,
                defaultDisclaimerScotland: null
            }
        },
        validations: {
            doorCheck: {
                document_id: { required },
                document_title: { required },
                client_site: { required },
                location: { required },
            },
        },
        methods: {
            clearEngineerSignature() {
                this.$refs.engineerSignaturePad.clearSignature();
            },
            saveEngineerSignature() {
                const { isEmpty, data } = this.$refs.engineerSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.doorCheck.offline_engineer_signature_image = {
                        data: data
                    };
                }
                
                this.addingEngineerSignature = false;
                this.clearEngineerSignature();
            },
            addEditEngineerSignature() {
                this.addingEngineerSignature = true;
            },
            clearClientSignature() {
                this.$refs.clientSignaturePad.clearSignature();
            },
            saveClientSignature() {
                const { isEmpty, data } = this.$refs.clientSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.doorCheck.offline_client_signature_image = {
                        data: data
                    };
                }
                
                this.addingClientSignature = false;
                this.clearClientSignature();
            },
            addEditClientSignature() {
                this.addingClientSignature = true;
            },
            onCountryChange() {
                if(this.dbName !== 'qfpc' && this.dbName !== 'dev') {
                    return;
                }

                if(this.doorCheck.country === 'Scotland') {
                    this.doorCheck.disclaimer = this.defaultDisclaimerScotland;
                } else {
                    this.doorCheck.disclaimer = this.defaultDisclaimer;
                }
            },
            getDefaultDisclaimer() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var objectStore = db.transaction('door_check_report_configurations').objectStore('door_check_report_configurations');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    vm.defaultDisclaimer = cursor.value.default_disclaimer;
                                    vm.defaultDisclaimerScotland = cursor.value.default_disclaimer_scotland !== undefined ? cursor.value.default_disclaimer_scotland : '';
                                    if (!vm.isEdit) {
                                        vm.doorCheck.disclaimer = vm.defaultDisclaimer;
                                    }
                                    cursor.continue();

                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getCpiScheduleItems() {
                var vm = this;
                this.getDb(function onConnected(db) {
                    vm.cpiScheduleItems = [];
                    try {
                        var objectStore = db.transaction('cpi_schedule_items').objectStore('cpi_schedule_items');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.cpiScheduleItems) {
                                        vm.cpiScheduleItems.push(cursor.value.cpi_schedule_item_title);
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getDoorCheck() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var doorCheckId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_checks').objectStore('door_checks');
                        var storeRequest = objectStore.get(doorCheckId);


                        storeRequest.onsuccess = function(event) {
                            vm.doorCheck = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.doorCheckFound = true;
                                if(vm.doorCheck.use_bm_trada_template === undefined) {
                                    vm.doorCheck.use_bm_trada_template = false;
                                }
                                if(vm.doorCheck.is_third_party_report === undefined) {
                                    vm.doorCheck.is_third_party_report = false;
                                }
                            }
                            vm.doorCheckLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.doorCheckFound = false;
                            vm.doorCheckLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.ignoreLeaveEvent = true;
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                var vm = this
                let request = new Promise((resolve, reject) => {
                    var vmt = vm;
                    vm.getDb(function onConnectedGetDoorSets(db) {
                        var vm = vmt;
                        var putRequest = db.transaction('door_checks', 'readwrite')
                            .objectStore('door_checks').put({
                                site_door_check_id: vm.doorCheck.site_door_check_id,
                                document_id: vm.doorCheck.document_id,
                                document_title: vm.doorCheck.document_title,
                                client_site: vm.doorCheck.client_site,
                                rma_form_sequential_ref_no: typeof vm.doorCheck.rma_form_sequential_ref_no == 'undefined' ? null : vm.doorCheck.rma_form_sequential_ref_no,
                                date_of_inspection: vm.doorCheck.date_of_inspection,
                                location: vm.doorCheck.location,
                                country: typeof vm.doorCheck.country == 'undefined' ? 'England' : vm.doorCheck.country,
                                notes: vm.doorCheck.notes,
                                include_notes_on_report: vm.doorCheck.include_notes_on_report,
                                disclaimer: vm.doorCheck.disclaimer,
                                client_provided_info_schedule: typeof vm.doorCheck.client_provided_info_schedule == 'undefined' ? null : vm.doorCheck.client_provided_info_schedule,
                                is_report_unbranded: vm.doorCheck.is_report_unbranded,
                                use_bm_trada_template: typeof vm.doorCheck.use_bm_trada_template == 'undefined' ? false : vm.doorCheck.use_bm_trada_template,
                                is_third_party_report: typeof vm.doorCheck.is_third_party_report == 'undefined' ? false : vm.doorCheck.is_third_party_report,
                                client_signature_image: vm.doorCheck.client_signature_image,
                                offline_client_signature_image: vm.doorCheck.offline_client_signature_image,
                                engineer_signature_image: vm.doorCheck.engineer_signature_image !== undefined ? vm.doorCheck.engineer_signature_image : null,
                                offline_engineer_signature_image: vm.doorCheck.offline_engineer_signature_image !== undefined ? vm.doorCheck.offline_engineer_signature_image : null,
                                client_signed_by: vm.doorCheck.client_signed_by,
                                report_version: typeof vm.doorCheck.report_version == 'undefined' ? null : vm.doorCheck.report_version,
                                user_id: vm.$session.get('user_id'),
                                prepared_by: typeof vm.doorCheck.prepared_by == 'undefined' ? null : vm.doorCheck.prepared_by,
                                edited_by: typeof vm.doorCheck.edited_by == 'undefined' ? null : vm.doorCheck.edited_by,
                                user: {
                                    user_id: vm.$session.get('user_id'),
                                    user_name: 'Phil',
                                }
                            });
                        putRequest.onsuccess = function(event) {
                            vm.submitSuccess({
                                success: true,
                                door_check_id: putRequest.result,
                            })
                        }
                        putRequest.onerror = function(event) {
                            alert("Unable to add data ");
                        }

                    })
                });
            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'door-check-view', params: {action: 'view', id: response.door_check_id} })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.doorCheck)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.doorCheck[field]) {
                    return this.$v.doorCheck[field];
                }
                throw Error('No validation for field ' + field);
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
            reload() {
                window.location = '';
            },
        },
        components: {
            Datepicker,
            Multiselect
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FDR') === -1) {
                this.$router.push('/');
                return;
            }

            this.getDefaultDisclaimer();
            this.getCpiScheduleItems();

            let doorCheckId = this.$route.params.id;
            if (doorCheckId) {
                this.isEdit = true;
                this.getDoorCheck();
            }
        },

    }
</script>